module.exports = __webpack_public_path__ + "static/img/twiter.d0e01fc1.png";